// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1oOQ-","error":"Textarea_error__3_Kh-","readonly":"Textarea_readonly__4Yu46","disabled":"Textarea_disabled__2AAjP"};